export default {
  gender: {
    en: 'Gender',
  },
  perfumes: {
    en: 'perfumes',
  },
  colognes: {
    en: 'colognes',
  },
  fragrance: {
    en: 'fragrance',
  },
  linkTitle: {
    male: {
      en: '{slug} for Men',
    },
    female: {
      en: '{slug} for Women',
    },
  },
}
